import {css} from '@emotion/react';
import {Typography} from '@mui/material';
import * as React from 'react';
import {FormattedMessage} from 'react-intl';
import {GetStylesFunction} from 'src/js/common/types';

interface OwnProps {
  activePage: number;
  count: number;
  countInPage: number;
  pageSize: number;
  isBig?: boolean;
}

type Props = OwnProps;

export const ResultCount: React.FC<Props> = (props) => {
  const {activePage, count, countInPage, pageSize, isBig} = props;
  const showingFrom = (activePage - 1) * pageSize + 1;
  const styles = getStyles();

  return (
    <Typography
      data-name={'result-count--result-count-wrapper'}
      css={isBig ? styles.resultCountWrapperBig : styles.resultCountWrapper}
      variant={'caption'}
    >
      <FormattedMessage
        id={isBig ? 'common.resultCountLong.text' : 'common.resultCount.text'}
        defaultMessage={'Showing {from} to {to} of {count} entries'}
        description={'label for collection (paginated result) count info'}
        values={{
          from: Number(showingFrom).toLocaleString('cs'),
          // added Math min in case we do not know countInPage, only pageSize
          to: Number(
            Math.min(showingFrom + countInPage - 1, count)
          ).toLocaleString('cs'),
          count: Number(count).toLocaleString('cs'),
        }}
      />
    </Typography>
  );
};

ResultCount.displayName = 'ResultCount';

const getStyles: GetStylesFunction = () => ({
  resultCountWrapper: css`
    text-align: right;
  `,
  resultCountWrapperBig: css`
    text-align: right;
    color: var(--dlAgGridGreySubtitleColor);
  `,
});
